import { gql } from '@apollo/client';

export const fetchNativeProductCollectionForCatalogue = gql`
  query fetchNativeProductCollectionForCatalogue($productKey: String, $offeringRelationshipType: String) {
    nativeCatalogForCollection(productKey: $productKey, offeringRelationshipType: $offeringRelationshipType) {
      nodes {
        productOfferingsForCollection {
          id
          product {
            id
            name
          }
        }
      }
    }
  }
`;
